// extracted by mini-css-extract-plugin
export default {"currenciesList":"CurrenciesList_currenciesList__iGSIo","inputSearch":"CurrenciesList_inputSearch__4KbwM","list":"CurrenciesList_list__LLfJA"};